"use strict";

const BmpFcsInventoryData = function () {
  let $page;

  var loadListeners = function ($parentPage, data) {
    $page = $parentPage;

    if (isPriorityCatchBasin(data)) {
      $page.on("change", `[name="sump"]`, toggleSumpDepthField);
      $page.on("change", `[name="shape"]`, toggleDiameterField);
    } else {
      BmpFcsInventoryBmpFcsInformation.showAdditionalFieldsByType(
        data.assetInfo.inventoryData.bmpType,
        $page,
      );
      hideNonStructuralAttributeFields($page);
    }
  };

  var unloadListeners = function () {
    $page.off("change", `[name="sump"]`, toggleSumpDepthField);
    $page.off("change", `[name="shape"]`, toggleDiameterField);
  };

  var getProps = function (data) {
    return {
      ...BmpFcsInventoryAdditionalCatchBasinInformation.getCatchBasinOptionProps(),
      ...BmpFcsInventoryAdditionalBmpInformation.getBmpOptionProps(),
      isPriorityCatchBasin: isPriorityCatchBasin(data),
      showInletOutletCounts: !isPriorityCatchBasin(data),
      inlets: data.assetInfo.inventoryData.inlets,
      outlets: data.assetInfo.inventoryData.outlets,
    };
  };

  var processUpdateData = function (dataToUpload, initial) {
    const inventoryData = initial.assetInfo.inventoryData;
    moveInventoryFieldsIntoAssetInfo(dataToUpload, inventoryData);

    if (dataToUpload.assetInfo) {
      BmpFcsInventoryModalController.processBmpFormData(dataToUpload.assetInfo, inventoryData);
    }
  };

  var moveInventoryFieldsIntoAssetInfo = function (dataToUpload, inventoryData) {
    for (const key in inventoryData) {
      for (const field of [key, `${key}Unit`]) {
        if (field in dataToUpload) {
          dataToUpload.assetInfo = dataToUpload.assetInfo ?? {};
          dataToUpload.assetInfo[field] = dataToUpload[field];
          delete dataToUpload[field];
        }
      }
    }
  };

  var highlightRequiredFields = function ($modal, data, assetInfo) {
    CommonModalFunctions.highlightEmptyFormFields(
      $modal,
      assetInfo.inventoryData.requiredFields ?? [],
      { ...data, ...assetInfo.inventoryData },
    );
  };

  var isPriorityCatchBasin = function (data) {
    return BmpFcsFunctions.isPriorityCatchBasinType(data.assetInfo.inventoryData.bmpType);
  };

  // Mirrors api/app/BmpFcs/BmpFcs.php `getAssetDisplayTypeAttribute()`
  var getAssetDisplayType = function (bmpFcs) {
    if (BmpFcsFunctions.isPriorityCatchBasinType(bmpFcs.bmpType)) {
      return ToolSettings.getSetting("constants", "assetDisplayNames", "catch-basin");
    } else if (bmpFcs.fcs) {
      return ToolSettings.getSetting("constants", "assetDisplayNames", "fcs");
    }

    return ToolSettings.getSetting("constants", "assetDisplayNames", "bmp");
  };

  // Mirrors api/app/Muni/MaintenanceInspectableResource.php `getSharedFields()`
  var mapAssetToAssetInfo = function (bmpFcs) {
    return {
      id: bmpFcs.id,
      name: bmpFcs.bmpName,
      assetType: "bmpFcs",
      assetDisplayType: getAssetDisplayType(bmpFcs),
      isHighPriority: bmpFcs.isCatchBasinHighPriority ?? false,
      lastInspectionDisplayDate: bmpFcs.lastInspectionDisplayDate,
      activeMaintenanceIssues: bmpFcs.activeMaintenanceIssues,
      inventoryData: {
        bmpType: bmpFcs.bmpType,
        fcs: bmpFcs.fcs,
        inlets: bmpFcs.inlets,
        outlets: bmpFcs.outlets,
        inletType: bmpFcs.inletType,
        totalDepth: bmpFcs.totalDepth,
        cleanout: bmpFcs.cleanout,
        sump: bmpFcs.sump,
        siphon: bmpFcs.siphon,
        designDepth: bmpFcs.designDepth,
        shape: bmpFcs.shape,
        length: bmpFcs.length,
        width: bmpFcs.width,
        diameter: bmpFcs.diameter,
        treatmentCapacity: bmpFcs.treatmentCapacity,
        footprint: bmpFcs.footprint,
        treatmentRate: bmpFcs.treatmentRate,
        infiltrationRate: bmpFcs.infiltrationRate,
        drawdownTime: bmpFcs.drawdownTime,
        wetPoolCapacity: bmpFcs.wetPoolCapacity,
        manufacturer: bmpFcs.manufacturer,
        nameModel: bmpFcs.nameModel,
        mediaType: bmpFcs.mediaType,
        filters: bmpFcs.filters,
        filterThickness: bmpFcs.filterThickness,
        footprintMaterial: bmpFcs.footprintMaterial,
        wallMaterial: bmpFcs.wallMaterial,
        datum: bmpFcs.datum,
        invertElevation: bmpFcs.invertElevation,
        baseElevation: bmpFcs.baseElevation,
        rimElevation: bmpFcs.rimElevation,
      },
    };
  };

  var hideNonStructuralAttributeFields = function ($thisPage) {
    $thisPage.find(`[data-field="treatment-capacity"]`).toggle(false);
    $thisPage.find(`[data-field="footprint"]`).toggle(false);
  };

  var toggleSumpDepthField = function () {
    const toggle = this.value === "true";
    $page.find(".sump-depth").toggleClass("hidden", !toggle);
  };

  var toggleDiameterField = function () {
    const toggle = this.value === "circular";
    $page.find(".length, .width").toggleClass("hidden", toggle);
    $page.find(".diameter").toggleClass("hidden", !toggle);
  };

  return {
    loadListeners,
    unloadListeners,
    getProps,
    highlightRequiredFields,
    processUpdateData,
    mapAssetToAssetInfo,
  };
};

module.exports = BmpFcsInventoryData();

const BmpFcsFunctions = require("../../../bmpfcs/bmpFcsFunctions");
const BmpFcsInventoryAdditionalBmpInformation = require("../../../bmpfcs/bmpFcsInventoryAdditionalBmpInformation");
const BmpFcsInventoryAdditionalCatchBasinInformation = require("../../../bmpfcs/bmpFcsInventoryAdditionalCatchBasinInformation");
const BmpFcsInventoryBmpFcsInformation = require("../../../bmpfcs/bmpFcsInventoryBmpFcsInformation");
const BmpFcsInventoryModalController = require("../../../bmpfcs/bmpFcsInventoryModalController");
const CommonModalFunctions = require("../../../modals/commonModalFunctions");
const ToolSettings = require("../../../settings/toolSettings");
